var StringHelper = /** @class */ (function () {
    function StringHelper() {
    }
    StringHelper.isNullOrWhiteSpace = function (value) {
        return (value == null || (value.trim() == "" || value.trim().length == 0));
    };
    return StringHelper;
}());
export { StringHelper };
